import React, { useState } from 'react';
import classes from './notifications.mobile.module.scss';
import SwitchComponent from 'components/common/Switch/Switch';
import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';
import NotificationGroup from 'components/App/AuthenticateLayout/Header/Notification/NotificationGroup/NotificationGroup';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';
import { useQueryGetNotifications } from 'components/App/AuthenticateLayout/Header/Notification/queries/useQueryNotifications';
import { groupNotificationsByDate } from 'components/App/AuthenticateLayout/Header/Notification/Notifications.utils';
import { IGetNotificationsResponse } from 'components/App/AuthenticateLayout/Header/Notification/Notifications.types';

export const Notifications = () => {
    const [showUnread, setShowUnread] = useState(false);
    const { isLoading, data: notifications } = useQueryGetNotifications();
    const filteredList = showUnread ? notifications?.filter((item) => !item.isRead) : notifications;
    const grouped = filteredList ? groupNotificationsByDate<IGetNotificationsResponse>({ list: filteredList }) : [];
    const title = `My Notifications (${filteredList?.length ?? 0})`;

    const handleShowUnread = () => {
        setShowUnread(!showUnread);
    };

    return (
        <WidgetWithTitle
            className={classes.notificationWidget}
            title={title}
            titleComponents={[
                <div key="readUnread" className={classes.item}>
                    Only show unread <SwitchComponent checked={showUnread} onChange={handleShowUnread} />
                </div>,
            ]}
        >
            <div className={classes.notificationList}>
                {isLoading && <OverlayWithSpinner />}

                <div className={classes.list}>
                    {grouped.length === 0 && (
                        <div className={classes.emptyList}>
                            <MuiIcon icon={'message'} fontSize={'9rem'} color="#9c9c9c" />
                            No notifications yet...
                        </div>
                    )}
                    {grouped.map((group) => (
                        <NotificationGroup key={group.title} group={group} />
                    ))}
                </div>
            </div>
        </WidgetWithTitle>
    );
};
